// This file was auto-generated by Fern from our API Definition.
/** The format of the timestamp value in the header. */
const WebhookTimestampFormatValues = {
    UnixSeconds: "UNIX_SECONDS",
    UnixMillis: "UNIX_MILLIS",
    Iso8601: "ISO8601",
};
export const WebhookTimestampFormat = Object.assign(Object.assign({}, WebhookTimestampFormatValues), { _visit: (value, visitor) => {
        switch (value) {
            case WebhookTimestampFormat.UnixSeconds:
                return visitor.unixSeconds();
            case WebhookTimestampFormat.UnixMillis:
                return visitor.unixMillis();
            case WebhookTimestampFormat.Iso8601:
                return visitor.iso8601();
            default:
                return visitor._other();
        }
    } });
